module.exports = __webpack_public_path__ + "static/img/linkman2.10655c0b.png";